import styled from '@emotion/styled'

import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'

const ProductInfoStyled = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media ${media.tablet} {
    flex-direction: row;
    justify-content: center;
  }
`

const ProductInfoMediasStyled = styled.div`
  @media ${media.maxTablet} {
    display: flex;
    justify-content: center;
  }
  @media ${media.tablet} {
    width: auto;
    max-width: 35.625rem;
  }
`

const ProductInfoContentStyled = styled.div`
  @media ${media.maxPhone} {
    margin-bottom: 3.75rem;
  }

  @media ${media.maxTablet} {
    text-align: center;
    margin: 0 auto 5rem;
  }
  @media ${media.tablet} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-right: 7.75rem;' : 'margin-left: 7.75rem;')}
  }
  @media ${media.desktop} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-right: 14rem;' : 'margin-left: 14rem;')}
  }
`

const ProductInfoContentWrapperStyled = styled.div`
  max-width: 33.5rem;
  width: 100%;
  @media ${media.maxPhone} {
    text-align: center;
  }
`

const ProductInfoTitleStyled = styled.div<WithTheme>`
  margin-bottom: 2.125rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};

  @media ${media.phone} {
    margin-bottom: 1.875rem;
  }
`

const ProductInfoDescriptionStyled = styled.div`
  margin-bottom: 2.25rem;
  @media ${media.phone} {
    margin-bottom: 2.375rem;
  }
`

const ProductInfoCtaStyled = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 11.125rem;

  @media ${media.maxTablet} {
    margin: 0 auto 1.25rem;
  }

  @media ${media.tablet} {
    align-items: flex-start;
    margin-bottom: 2.875rem;
    max-width: 12.75rem;
  }
`

const ProductInfoCtaCaptionStyled = styled.div`
  margin: 0.25rem auto 0;

  @media ${media.phone} {
    margin: 0.5rem auto 0;
  }
`

const ProductInfoCaptionStyled = styled.div``

const ProductInfoDemoLinkStyled = styled.a<WithTheme>`
  color: ${({ theme }) => theme.colors.blue2};

  &:hover {
    text-decoration: underline;
  }
`

export {
  ProductInfoStyled,
  ProductInfoMediasStyled,
  ProductInfoContentStyled,
  ProductInfoTitleStyled,
  ProductInfoDescriptionStyled,
  ProductInfoCtaStyled,
  ProductInfoCtaCaptionStyled,
  ProductInfoCaptionStyled,
  ProductInfoDemoLinkStyled,
  ProductInfoContentWrapperStyled
}
